/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to modify the title of a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeTitleCommand extends AbstractCommand {
    public _newTitle : string;

    public _oldTitle : string;

    public _nullInfo : boolean;

    public constructor(newTitle? : any) {
        if(((typeof newTitle === 'string') || newTitle === null)) {
            let __args = arguments;
            super();
            if(this._newTitle===undefined) this._newTitle = null;
            if(this._oldTitle===undefined) this._oldTitle = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newTitle===undefined) this._newTitle = null;
            if(this._oldTitle===undefined) this._oldTitle = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            (() => {
                this._newTitle = newTitle;
            })();
        } else if(newTitle === undefined) {
            let __args = arguments;
            super();
            if(this._newTitle===undefined) this._newTitle = null;
            if(this._oldTitle===undefined) this._oldTitle = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newTitle===undefined) this._newTitle = null;
            if(this._oldTitle===undefined) this._oldTitle = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeTitleCommand] Executing.");
        if(ModelUtils.isNullOrUndefined(document.info)) {
            document.info = document.createInfo();
            this._nullInfo = true;
            this._oldTitle = null;
        } else {
            this._oldTitle = document.info.title;
        }
        document.info.title = this._newTitle;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeTitleCommand] Reverting.");
        if(this._nullInfo) {
            document.info = null;
        } else {
            document.info.title = this._oldTitle;
        }
    }
}
ChangeTitleCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeTitleCommand";
ChangeTitleCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




